<template>
  <p class="h3">
    {{ time | secondsToTimeFormat }}
  </p>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
    },
  },
  data() {
    return {
      time: 0,
      timer: null,
    };
  },

  created() {
    this.startTimer();
  },

  watch: {
    status(val) {
      if (val === "play") this.startTimer();
      if (val === "pause") this.stopTimer();
    },
  },
  methods: {
    stopTimer() {
      clearInterval(this.timer);
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.time += 1;
      }, 1000);
    },
    resetTimer() {
      this.time = 0;
      this.stopTimer();
    },
  },
};
</script>

<style></style>
